import { StyleService } from '@wix/members-area-commons-ts';

import { getViewMode } from '../state/site/selectors';
import { VIEW_MODE_EDITOR, VIEW_MODE_PREVIEW } from '../constants/view-modes';
import { EVENT_GENERATED_STYLES_ID } from '../constants/dom';

const toCssClass = (className, value) => `
  [dir] .${className} {
    ${value};
  }`;

export default (store, { fonts = [], colors = [] }) => (styleParams) => {
  const styles = document.getElementById(EVENT_GENERATED_STYLES_ID);
  const viewMode = getViewMode(store.getState());
  const inEditor = viewMode === VIEW_MODE_EDITOR || viewMode === VIEW_MODE_PREVIEW;

  const { renderColorWithOpacity, renderFontWithInitialSize } = new StyleService({
    styleParams,
    siteTextPresets: Wix.Styles.getSiteTextPresets(),
    siteColors: Wix.Styles.getSiteColors(),
    inEditor,
  });

  let newStyle = '';

  colors.forEach(({ className, wixParam, css, defaultColorReference, initialOpacity, fixedOpacity }) => {
    newStyle += toCssClass(
      className,
      renderColorWithOpacity(wixParam, css, defaultColorReference, initialOpacity, fixedOpacity),
    );
  });

  fonts.forEach(({ className, wixParam, defaultThemeName, initialFontSize }) => {
    newStyle += toCssClass(className, renderFontWithInitialSize(wixParam, defaultThemeName, initialFontSize));
  });

  styles.innerHTML = newStyle;
};
